const INITIAL_STATE = {
    registro: {},
    aguardando: false,
    modoTela: "lista",
    lista: [],
    listaGestorConcessionariaSelect: [],
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "GESTOR_CONCESSIONARIA_MODO_TELA":
            return {
                ...state,
                modoTela: action.payload.modo,
                registro: action.payload.registro,
            };

        case "GESTOR_CONCESSIONARIA_SET_AGUARDANDO":
            return { ...state, aguardando: action.payload };

        case "GESTOR_CONCESSIONARIA_FILTRO":
            return { ...state, filtro: action.payload };

        case "GESTOR_CONCESSIONARIA_LISTADO":
            return {
                ...state,
                lista: action.payload.data,
            };
        case "GESTOR_CONCESSIONARIA_SELECT_LISTADO":
            return {
                ...state,
                listaGestorConcessionariaSelect: action.payload.data,
            };

        default:
            return state;
    }
};
